import { createContext } from "react";

import { ECU } from "shared/api/api";
import { useListECUs } from "shared/api/hooks";

import { ContextWrapComponentProps } from "./types";

const MAX_LIMIT_ECUS = 2000;

export const VehicleECUsContext = createContext<{
  ECUs: ECU[] | undefined;
}>({ ECUs: undefined });

const VehicleECUsContextWrapper = ({ children }: ContextWrapComponentProps) => {
  const { data: ECUs } = useListECUs({ limit: MAX_LIMIT_ECUS });

  return (
    <VehicleECUsContext.Provider value={{ ECUs }}>
      {children}
    </VehicleECUsContext.Provider>
  );
};

export default VehicleECUsContextWrapper;
